import axiosApi from '../../../../Shared/api/axiosApi';

class CRMApi {
    static getCrmArticles(searchString) {
        return axiosApi.get('CustomerService/Articles/' + searchString, true)
        .then(response => {
            return response;
        }).catch(error => {
            throw error;
        });
    }
}

export default CRMApi;  